module.exports = __webpack_public_path__ + "img/instructions_2@2x.919ed95c.png";